import { templatesRegistry } from 'utils/templates';

let currentAxonKey = null;

export function initAxonPixel(templateId) {
  const template = templatesRegistry.getConfig(templateId);
  const enableAxonPixel = template?.enableAxonPixel;
  const axonEventKey = template?.axonEventKey;

  if (!enableAxonPixel || !axonEventKey) {
    window.axon = null;
    return;
  }

  if (window.axon && currentAxonKey === axonEventKey) {
    return;
  }

  if (window.axon && currentAxonKey && currentAxonKey !== axonEventKey) {
    window.axon = null;
  }

  currentAxonKey = axonEventKey;

  window.AXON_EVENT_KEY = axonEventKey;

  // Loader snippet from Axon docs:
  // https://support.axon.ai/en/growth/promoting-your-websites/axon-pixel-integration/google-tag-manager
  (function (e, r) {
    var urls = [
      'https://s.axon.ai/pixel.js',
      'https://res4.applovin.com/p/l/loader.iife.js',
    ];
    if (!e.axon) {
      var a = (e.axon = function () {
        a.performOperation
          ? a.performOperation.apply(a, arguments)
          : a.operationQueue.push(arguments);
      });
      a.operationQueue = [];
      a.ts = Date.now();
      a.eventKey = window.AXON_EVENT_KEY;

      var firstScript = r.getElementsByTagName('script')[0];
      for (var i = 0; i < urls.length; i++) {
        var s = r.createElement('script');
        s.async = true;
        s.src = urls[i];
        firstScript.parentNode.insertBefore(s, firstScript);
      }
    }
  })(window, document);

  window.axon('init');
}
